// extracted by mini-css-extract-plugin
export var footer = "r_bd";
export var footerUpper = "r_bf";
export var logoLink = "r_bg";
export var navMenu = "r_bh";
export var divider = "r_T";
export var footerLower = "r_bj";
export var rotate = "r_c";
export var dotty = "r_d";